import React from "react";
import MemberModal from "./components/MemberModal";

const Finance = ({ fontSize }) => {
  return (
    <div>
      <div className="financeDiv membersDiv ">
        <div className="cardContainer grid-container">
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Finance"
            name="Ethan Zhang "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/ethan-zhang-profile.png"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/ethan-zhang-silly.png "
            }
            program="Computer Science "
            term="3A "
            bird="Perpetually Tired "
            lab="Scale "
            travel="Germany "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Finance"
            name="Sabrina Valeri "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/sabrina-valeri-profile.jpeg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/sabrina-valeri-silly.jpeg "
            }
            program="Science and Business with Biology Specialization "
            term="4A "
            bird="Night Owl "
            lab="Microscope "
            travel="Italy "
          />
        </div>
      </div>
    </div>
  );
};

export default Finance;
